import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import warehouse from './modules/warehouse'
import floor from './modules/floor'
import threshold from './modules/threshold'
import ththreshold from './modules/ththreshold'
import company from './modules/company'
import equipment from './modules/equipment'
import gasequipment  from './modules/gasequipment';
import thequipment from './modules/thequipment'
import gwequipment from './modules/gwequipment'
import smokecrib from './modules/smokecrib'
import data from './modules/data'
import common from './modules/common'
import thdata from './modules/thdata'
import factory from './modules/factory'
import thhandlewarning from './modules/thhandlewarning'
import auditlog from './modules/auditlog'
import userloginattempt from './modules/userloginattempt'
import gasthreshold from './modules/gasthreshold'
import inairthreshold from './modules/inairthreshold'
import inairequipment from './modules/inairequipment';
import outair_equipment from './modules/outair_equipment';
import outair_data from './modules/outair_data';
import outair_handlewarning from './modules/outair_handlewarning';
import outair_threshold from './modules/outair_threshold';
import moisturedata from './modules/moisturedata';
import moistureequipment from './modules/moistureequipment';
import moisturehandlewarning from './modules/moisturehandlewarning';
import moisturethreshold from './modules/moisturethreshold';
import gasdata from './modules/gasdata';
import inairdata from './modules/inairdata';
import smokeleaf from './modules/smokeleaf';
import inairhandlewarning from './modules/inairhandlewarning';
import gashandlewarning from './modules/gashandlewarning';
import handlewarning from './modules/handlewarning';
import trapthdata from './modules/trapthdata';
const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        warehouse,
        floor,
        threshold,
        company,
        equipment,
        thequipment,
        gwequipment,
        smokecrib,
        data,
        common,
        ththreshold,
        thdata,
        factory,
        thhandlewarning,
        auditlog,
        userloginattempt,
        gasequipment,
        gasthreshold,
        inairthreshold,
        inairequipment,
        outair_equipment,
        outair_data,
        outair_handlewarning,
        outair_threshold,
        moisturedata,
        moistureequipment,
        moisturehandlewarning,
        moisturethreshold,
        gasdata,
        inairdata,
        smokeleaf,
        inairhandlewarning,
        gashandlewarning,
        handlewarning,
        trapthdata
    }
});

export default store;